type DateCollector = {
  days: string[],
  months: string[],
  years: string[],
}

const days = Array.from({ length: 31 }, (_, index) => `${index + 1}`);

const months = Array.from({ length: 12 }, (_, index) => `${index + 1}`);

const currentYear = new Date().getFullYear();
const startYear = 1900; // Starting year
const yearsLength = currentYear - 18 - startYear + 1;

const years = Array.from({ length: yearsLength }, (_, index) => `${startYear + index}`);

export const dateCollector: DateCollector = {
  days: days,
  months: months,
  years: years
};
